import { render, staticRenderFns } from "./enterprisesCityRelation-province.vue?vue&type=template&id=172779c5&scoped=true&"
import script from "./enterprisesCityRelation-province.vue?vue&type=script&lang=js&"
export * from "./enterprisesCityRelation-province.vue?vue&type=script&lang=js&"
import style0 from "./enterprisesCityRelation-province.vue?vue&type=style&index=0&id=172779c5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172779c5",
  null
  
)

export default component.exports